import TransferAlatMesinProduksiAsetApi from './TransferAlatMesinProduksiAsetApi';

export default TransferAlatMesinProduksiAsetApi;
